import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

// Whenever the page (re)enters readonly mode - on mount, after cancel, or
// after a successful save - snaps the form and workflow selections back to
// the active version's canonical values.
export const useResetFormOnReadonlyChange = ({
  readonly,
  methods,
  inputData,
  formFieldsObject,
  setDefaultWorkflows,
  setCustomWorkflows,
  setIsEditWorkflowMode,
  setSelectedWorkflow,
}: {
  readonly: boolean;
  methods: UseFormReturn<any>;
  inputData: any;
  formFieldsObject: Record<string, any>;
  setDefaultWorkflows: (workflows: any[]) => void;
  setCustomWorkflows: (workflows: any[]) => void;
  setIsEditWorkflowMode: (value: boolean) => void;
  setSelectedWorkflow: (value: any) => void;
}) => {
  useEffect(() => {
    if (!readonly) {
      return;
    }

    methods.reset({
      pf_ai_name: inputData?.pf_ai_name || '',
      pf_company_name: inputData?.pf_company_name || '',
      pf_company_description: inputData?.pf_company_description || '',
      pf_pages: inputData?.pf_pages || [],
      pf_role: inputData?.pf_role || formFieldsObject?.pf_role?.default_value?.value || 'support',
      pf_role_custom: inputData?.pf_role_custom || '',
      pf_cta: inputData?.pf_cta || null,
      pf_icp: inputData?.pf_icp || null,
      pf_tone_of_voice_channel:
        inputData?.pf_tone_of_voice_channel ||
        formFieldsObject?.pf_tone_of_voice_channel?.default_value?.value ||
        'chat',
      pf_tone_of_voice_style:
        inputData?.pf_tone_of_voice_style ||
        formFieldsObject?.pf_tone_of_voice_style?.default_value?.value ||
        'casual',
      pf_tone_of_voice_style_custom: inputData?.pf_tone_of_voice_style_custom || '',
      pf_tone_of_voice_emoji:
        typeof inputData?.pf_tone_of_voice_emoji === 'boolean'
          ? inputData?.pf_tone_of_voice_emoji
          : formFieldsObject?.pf_tone_of_voice_emoji?.default_value?.value || false,
      pf_tone_of_voice_resp_len:
        inputData?.pf_tone_of_voice_resp_len ||
        formFieldsObject?.pf_tone_of_voice_resp_len?.default_value?.value ||
        'concise',
      pf_default_language: inputData?.pf_default_language
        ? { key: inputData?.pf_default_language, value: inputData?.pf_default_language }
        : formFieldsObject?.pf_default_language?.default_value
          ? {
              key: formFieldsObject?.pf_default_language?.default_value,
              value: formFieldsObject?.pf_default_language?.default_value,
            }
          : {},
      pf_excluded_languages: inputData?.pf_excluded_languages?.length
        ? inputData?.pf_excluded_languages.map((lang: string) => ({ key: lang, value: lang }))
        : [],
      pf_words_blacklist: inputData?.pf_words_blacklist || [],
      pf_custom_workflows: inputData?.pf_custom_workflows || [],
      pf_default_workflow: inputData?.pf_default_workflow || {},
    });

    setDefaultWorkflows(inputData?.pf_default_workflow ? [inputData.pf_default_workflow] : []);
    setCustomWorkflows(inputData?.pf_custom_workflows || []);
    setIsEditWorkflowMode(false);
    setSelectedWorkflow(null);
  }, [readonly]);
};
